import classnames from 'classnames';
import React from 'react';

export type StepNumberProps = { number: number; complete: boolean; active: boolean };

export const StepNumber = ({ number, active, complete }: StepNumberProps) => {
  return <div className={classnames('step-number', { active: active, complete: complete && !active })}>{number}</div>;
};
